import { createAction } from 'typesafe-actions';
import { IInsect } from '../../../types/model/masterData/insect';

export default class InsectActions {
    public static setLoading = createAction('MASTER_DATA_INSECT_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('MASTER_DATA_INSECT_SET', resolve => (blocks : Array<IInsect>) => resolve(blocks));
}